import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faBars,
    faHome,
    faBell,
    faUser,
    faBullseye,
    faEye,
    faPencilAlt,
    faWindowClose,
    faTrash,
    faPrint,
    faSuitcase,
    faPaperclip,
    faAngleDown,
    faAngleUp,
    faTimes,
    faDownload,
    faUpload,
    faFileAlt,
    faHeadphones,
    faCogs,
    faCog,
    faIndustry,
    faAngleRight,
    faAngleLeft,
    faEllipsisV,
    faPlus,
    faMinus,
    faBriefcase,
    faCamera,
    faExternalLinkAlt,
    faFile,
    faFileImage,
    faList,
    faHandPaper,
    faEyeSlash,
    faShieldAlt,
    faImage,
    faPowerOff,
    faFolderOpen,
    faFolder,
    faCircleNotch,
    faCircle,
    faDotCircle,
    faSquare,
    faArrowRight,
    faArrowLeft,
    faUndo,
    faRedo,
    faFilePdf,
    faBook,
    faComments,
    faPaperPlane,
    faSave,
    faChartLine

} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(
    faBars,
    faHome,
    faBell,
    faUser,
    faEye,
    faBullseye,
    faPencilAlt,
    faWindowClose,
    faTrash,
    faPrint,
    faSuitcase,
    faPaperclip,
    faAngleDown,
    faAngleUp,
    faAngleRight,
    faAngleLeft,
    faTimes,
    faFileAlt,
    faHeadphones,
    faIndustry,
    faEllipsisV,
    faPlus,
    faCogs,
    faCog,
    faBriefcase,
    faDownload,
    faUpload,
    faCamera,
    faExternalLinkAlt,
    faFile,
    faFileImage,
    faFilePdf,
    faList,
    faHandPaper,
    faEyeSlash,
    faShieldAlt,
    faImage,
    faPlus,
    faMinus,
    faTimes,
    faPowerOff,
    faFolderOpen,
    faFolder,
    faCircleNotch,
    faCircle,
    faDotCircle,
    faSquare,
    faArrowRight,
    faArrowLeft,
    faUndo,
    faRedo,
    faBook,
    faComments,
    faPaperPlane,
    faSave,
    faChartLine
)

Vue.component('font-awesome-icon', FontAwesomeIcon)